import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Top 10 Villes ( Colis Livré)", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-8" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary mr-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.FilterData && _ctx.FilterData(...args)))
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "flaticon-search" }, null, -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ClearFilterData && _ctx.ClearFilterData(...args)))
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "flaticon-close" }, null, -1)
          ]))
        ])
      ]),
      _createElementVNode("div", {
        style: _normalizeStyle([_ctx.display ? { display: 'none' } : '']),
        class: "chart"
      }, [
        _createVNode(_component_apexchart, {
          type: "bar",
          height: "325",
          options: _ctx.productOrdersRadialBar.chartOptions,
          series: _ctx.productOrdersRadialBar.series
        }, null, 8, ["options", "series"])
      ], 4)
    ])
  ]))
}